import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@heroui/react";
import { formatInvoicePeriodDate } from "@/pages/Dashboard/CustomerSubscriptionOverview/components/subscriptionInvoiceUtils";

type SubscriptionSharePeriod = {
  id: number;
  periodStart: Date | string;
  periodEnd: Date | string;
};

export function SubscriptionShareModal({
  variant,
  isOpen,
  shares,
  isLoading,
  onConfirm,
  onClose,
}: {
  variant: "markPaid" | "markUnpaid";
  isOpen: boolean;
  shares: SubscriptionSharePeriod[];
  isLoading: boolean;
  onConfirm: (updateSubscriptionShares: boolean) => Promise<void>;
  onClose: () => void;
}) {
  const copy =
    variant === "markPaid"
      ? {
          modalId: "subscription-share-payment-modal",
          title: t`Označi tudi obdobje paketa kot plačano?`,
          description: t`Račun je izdan za obdobje paketa, ki še ni označeno kot plačano:`,
          invoiceOnlyId: "confirm-payment-invoice-only",
          withSubscriptionId: "confirm-payment-with-subscription",
        }
      : {
          modalId: "subscription-share-cancel-modal",
          title: t`Označi tudi obdobje paketa kot neplačano?`,
          description: t`Račun je izdan za obdobje paketa, ki je označeno kot plačano:`,
          invoiceOnlyId: "cancel-invoice-only",
          withSubscriptionId: "cancel-invoice-with-subscription",
        };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      placement="top-center"
      data-identifier={copy.modalId}
    >
      <ModalContent>
        <ModalHeader>{copy.title}</ModalHeader>
        <ModalBody>
          <p className="text-sm">{copy.description}</p>
          <ul className="list-disc pl-5 text-sm">
            {shares.map((share) => (
              <li key={share.id}>
                {formatInvoicePeriodDate(share.periodStart)} –{" "}
                {formatInvoicePeriodDate(share.periodEnd)}
              </li>
            ))}
          </ul>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="flat"
            isDisabled={isLoading}
            onPress={() => onConfirm(false)}
            data-identifier={copy.invoiceOnlyId}
          >
            <Trans>Samo račun</Trans>
          </Button>
          <Button
            color="primary"
            isLoading={isLoading}
            onPress={() => onConfirm(true)}
            data-identifier={copy.withSubscriptionId}
          >
            <Trans>Račun in paket</Trans>
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
